import styled from '@emotion/styled'
import React, { useEffect, useMemo} from 'react'
import {PALETTE} from '../../styles/paletteV3'

import {DragAttribute, ElementWidth, ZIndex} from '../../types/constEnums'


import ExpandedReflection from './ExpandedReflection'
import getBBox from './getBBox'

const PortalBlock = styled('div')({
  height: '100%',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: ZIndex.DIALOG
})

const Scrim = styled('div')({
  position: 'fixed',
  height: '100%',
  width: '100%'
})

const PhaseArea = styled('div')(({phaseBBox}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  zIndex: ZIndex.DIALOG,
  // use phaseBBox to center in the phase, not the screen (ignores left nav & fac nav bar)
  top: phaseBBox.top,
  left: phaseBBox.left,
  width: phaseBBox.width,
  height: phaseBBox.height
}))

const ModalArea = styled('div')({
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100vh - 32px)',
  position: 'relative'
})

const BackgroundBlock = styled('div')({
  position: 'absolute',
  background: PALETTE.SLATE_700_80,
  borderRadius: 4,
  height: '100%',
  width: '100%',
  zIndex: -1 // keep scrollbar visible
})

const ScrollBlock = styled('div')({
  width: 'min-content',
  display: 'flex',
  flexWrap: 'wrap',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: ElementWidth.REFLECTION_CARD_PADDING
})
















const ExpandedReflectionStack = (props) => {
  const {
    header,
    staticReflections,
    phaseRef,
    scrollRef,
    setItemsRef,
    bgRef,
    closePortal,
    reflections,
    reflectionGroupId,
    meeting,
    openSpotlight,
    isBehindSpotlight
  } = props
  const phaseBBox = useMemo(() => {
    return getBBox(phaseRef.current)
  }, [phaseRef.current])
  useEffect(() => {
    const handleKeydown = (e) => {
      const {activeElement, body} = document
      if (e.key === 'Escape' && activeElement === body) {
        closePortal()
      }
    }
    document.addEventListener('keydown', handleKeydown)
    return () => {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [])
  if (!phaseBBox) return null

  const closeOnEdge = (e) => {
    if (e.target === e.currentTarget) closePortal()
  }
  return (
    React.createElement(PortalBlock, null
      , React.createElement(PhaseArea, { phaseBBox: phaseBBox,}
        , React.createElement(Scrim, { onClick: closePortal,} )
        , React.createElement(ModalArea, { ...(isBehindSpotlight ? null : {[DragAttribute.DROPPABLE]: reflectionGroupId}),}
          , header
          , React.createElement(ScrollBlock, { ref: scrollRef, onClick: closeOnEdge,}
            , reflections.map((reflection, idx) => {
              return (
                React.createElement(ExpandedReflection, {
                  key: reflection.id,
                  reflection: reflection,
                  meeting: meeting,
                  openSpotlight: openSpotlight,
                  idx: idx,
                  setItemsRef: setItemsRef,
                  staticReflections: staticReflections,}
                )
              )
            })
          )
          , React.createElement(BackgroundBlock, { ref: bgRef,} )
        )
      )
    )
  )
}

export default ExpandedReflectionStack
